import { styled } from '@mui/material/styles';

export const CustomMenuButton = styled('button')(({ theme }) => ({
  '.video-js &.vjs-button': {
    background: '#000',
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    top: '50%',
    transform: 'translateY(-50%)',
    height: 70,
    width: 70,
    opacity: 0.5,
    borderRadius: '50%',
    cursor: 'pointer',

    '&:hover': {
      opacity: 1,
    },

    '&.play-pause-button': {
      display: 'none',
      [theme.breakpoints.down('lg')]: {
        display: 'flex',
        background: 'transparent',
        fontSize: '40px',
        right: '45%',
      },
    },

    [theme.breakpoints.down('lg')]: {
      fontSize: 14,
      height: 60,
      width: 60,
    },

    [theme.breakpoints.down('md')]: {
      fontSize: 12,
      height: 45,
      width: 45,
    },
  },
}));
